import { render } from "./AboutView.vue?vue&type=template&id=08e15c88&scoped=true"
import script from "./AboutView.vue?vue&type=script&lang=js"
export * from "./AboutView.vue?vue&type=script&lang=js"

import "./AboutView.vue?vue&type=style&index=0&id=08e15c88&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/personal-website/personal-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08e15c88"]])

export default __exports__